import { render, staticRenderFns } from "./CategoryContentReviewDialog.pug?vue&type=template&id=2ee10d6e&lang=pug&external"
import script from "./CategoryContentReviewDialog.js?vue&type=script&lang=js&external"
export * from "./CategoryContentReviewDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports